/* istanbul ignore next */
const imageDimensions = (file: Blob): Promise<{
  width: number, height: number
}> => new Promise(resolve => {
  const img = new Image()
  img.src = URL.createObjectURL(file)
  img.onload = () => {
    resolve({ width: img.naturalWidth, height: img.naturalHeight })
  }
})

export default imageDimensions
